export default __webpack_public_path__ + "static/media/tdex-color.7e3b1a7c.svg";